module.exports = __webpack_public_path__ + "img/Inside-sp_5.6e1005aa.jpg";